module.exports = __webpack_public_path__ + "img/Birte-Schmidt-v2-500.b1304b79.jpg";